import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import villaImage from '../../../../assets/home/VillaImage.png';
import noise2 from '../../../../assets/Noise2.svg';
import { aboutSectionStyles } from './AboutSection.styles';
import { useNavigate } from 'react-router-dom';

const AboutSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <Box ref={containerRef} sx={aboutSectionStyles.container}>
      {/* Noise overlay */}
      <Box
        component="img"
        src={noise2}
        alt=""
        loading="lazy"
        sx={aboutSectionStyles.noiseOverlay}
      />

      {/* Text Content */}
      <Box
        sx={{
          ...aboutSectionStyles.textContainer,
          ...aboutSectionStyles.fadeInText(isVisible),
        }}
        pl={{xs: 3, lg: 10}}
        pr={{xs: 3, lg: 0}}
      >
        <Typography sx={aboutSectionStyles.header}>About</Typography>
        <Typography sx={aboutSectionStyles.title} mb={1}>Royal Vista</Typography>
        <Typography sx={aboutSectionStyles.description}>
          Royal Vista curates premium residences designed for comfort, elegance, and exceptional stays. We focus on creating refined living experiences by carefully selecting properties that meet high standards of quality, design, and location.
          <br /><br />
          Every residence is thoughtfully prepared and professionally managed to ensure consistency, reliability, and attention to detail at every stage of the stay. From first impression to departure, our approach is centered on comfort, ease, and peace of mind.
        </Typography>
        <Button
          variant="contained"
          disableElevation
          color="secondary"
          sx={aboutSectionStyles.button}
          onClick={() => navigate('/about')}
        >
          View More
        </Button>
      </Box>

      {/* Villa Image */}
      <Box
        component="img"
        src={villaImage}
        alt="Villa"
        loading="lazy"
        sx={{
          ...aboutSectionStyles.villaImage,
          ...aboutSectionStyles.fadeInImage(isVisible),
        }}
      />
    </Box>
  );
};

export default AboutSection;

